import { CategoryData } from '../../../../types/types';

export const nombres: CategoryData = {
    // Nombres de base (1-10)
    'Kelen': {
        translation: 'Un',
        translationEn: 'One',
        illustration: '1️⃣',
        audio: 'Ba-kelen',
        displayName: 'Kelen'
    },
    'Fila': {
        translation: 'Deux',
        translationEn: 'Two',
        illustration: '2️⃣',
        audio: 'Ba-fila',
        displayName: 'Fila'
    },
    'Saba': {
        translation: 'Trois',
        translationEn: 'Three',
        illustration: '3️⃣',
        audio: 'Ba-saba',
        displayName: 'Saba'
    },
    'Naani': {
        translation: 'Quatre',
        translationEn: 'Four',
        illustration: '4️⃣',
        audio: 'Ba-naani',
        displayName: 'Naani'
    },
    'Duuru': {
        translation: 'Cinq',
        translationEn: 'Five',
        illustration: '5️⃣',
        audio: 'Ba-duuro',
        displayName: 'Duuru'
    },
    'Wɔɔrɔ': {
        translation: 'Six',
        translationEn: 'Six',
        illustration: '6️⃣',
        audio: 'Ba-wooro',
        displayName: 'Wɔɔrɔ'
    },
    'Wolonfila': {
        translation: 'Sept',
        translationEn: 'Seven',
        illustration: '7️⃣',
        audio: 'Ba-wolonfila',
        displayName: 'Wolonfila'
    },
    'Segin': {
        translation: 'Huit',
        translationEn: 'Eight',
        illustration: '8️⃣',
        audio: 'Ba-segin',
        displayName: 'Segin'
    },
    'Kɔnɔntɔn': {
        translation: 'Neuf',
        translationEn: 'Nine',
        illustration: '9️⃣',
        audio: 'Ba-koronton',
        displayName: 'Kɔnɔntɔn'
    },
    'Tan': {
        translation: 'Dix',
        translationEn: 'Ten',
        illustration: '🔟',
        audio: 'Ba-tan',
        displayName: 'Tan'
    },

    // Dizaines (10-90)
    'Tan ni kelen': {
        translation: 'Onze',
        translationEn: 'Eleven',
        illustration: '1️⃣1️⃣',
        audio: 'Ba-tan-ni-kelen',
        displayName: 'Tan ni kelen'
    },
    'Tan ni fila': {
        translation: 'Douze',
        translationEn: 'Twelve',
        illustration: '1️⃣2️⃣',
        audio: 'Ba-tan-ni-fila',
        displayName: 'Tan ni fila'
    },
    'Tan ni saba': {
        translation: 'Treize',
        translationEn: 'Thirteen',
        illustration: '1️⃣3️⃣',
        audio: 'Ba-tan-ni-saba',
        displayName: 'Tan ni saba'
    },
    'Tan ni naani': {
        translation: 'Quatorze',
        translationEn: 'Fourteen',
        illustration: '1️⃣4️⃣',
        audio: 'Ba-tan-ni-naani',
        displayName: 'Tan ni naani'
    },
    'Tan ni duuru': {
        translation: 'Quinze',
        translationEn: 'Fifteen',
        illustration: '1️⃣5️⃣',
        displayName: 'Tan ni duuru'
    },
    'Tan ni wooro': {
        translation: 'Seize',
        translationEn: 'Sixteen',
        illustration: '1️⃣6️⃣',
        audio: 'Ba-tan-ni-wooro',
        displayName: 'Tan ni wooro'
    },
    'Tan ni woorofila': {
        translation: 'Dix sept',
        translationEn: 'Seventeen',
        illustration: '1️⃣7️⃣',
        audio: 'Ba-tan-ni-woorofila',
        displayName: 'Tan ni woorofila'
    },
    'Tan ni segin': {
        translation: 'Dix huit',
        translationEn: 'Eighteen',
        illustration: '1️⃣8️⃣',
        audio: 'Ba-tan-ni-segin',
        displayName: 'Tan ni segin'
    },
    'Tan ni kolonton': {
        translation: 'Dix neuf',
        translationEn: 'Nineteen',
        illustration: '1️⃣9️⃣',
        audio: 'Ba-tan-ni-kolonton',
        displayName: 'Tan ni kolonton'
    },
    'Mugan': {
        translation: 'Vingt',
        translationEn: 'Twenty',
        illustration: '2️⃣0️⃣',
        audio: 'Ba-mugan',
        displayName: 'Mugan'
    },
    'Bisaba': {
        translation: 'Trente',
        translationEn: 'Thirty',
        illustration: '3️⃣0️⃣',
        audio: 'Ba-bisaba',
        displayName: 'Bisaba'
    },
    'Binaani': {
        translation: 'Quarante',
        translationEn: 'Forty',
        illustration: '4️⃣0️⃣',
        displayName: 'Binaani'
    },
    'Biduuru': {
        translation: 'Cinquante',
        translationEn: 'Fifty',
        illustration: '5️⃣0️⃣',
        displayName: 'Biduuru'
    },
    'Biwɔɔrɔ': {
        translation: 'Soixante',
        translationEn: 'Sixty',
        illustration: '6️⃣0️⃣',
        audio: 'Ba-biwooro',
        displayName: 'Biwɔɔrɔ'
    },
    'Biwolonfila': {
        translation: 'Soixante-dix',
        translationEn: 'Seventy',
        illustration: '7️⃣0️⃣',
        displayName: 'Biwolonfila'
    },
    'Bisegin': {
        translation: 'Quatre-vingts',
        translationEn: 'Eighty',
        illustration: '8️⃣0️⃣',
        displayName: 'Bisegin'
    },
    'Bikɔnɔntɔn': {
        translation: 'Quatre-vingt-dix',
        translationEn: 'Ninety',
        illustration: '9️⃣0️⃣',
        displayName: 'Bikɔnɔntɔn'
    },

    // Centaines (100-900)
    'Kɛmɛ': {
        translation: 'Cent',
        translationEn: 'One hundred',
        illustration: '💯',
        displayName: 'Kɛmɛ'
    },
    'Kɛmɛ fila': {
        translation: 'Deux cents',
        translationEn: 'Two hundred',
        illustration: '2️⃣0️⃣0️⃣',
        displayName: 'Kɛmɛ fila'
    },
    'Kɛmɛ saba': {
        translation: 'Trois cents',
        translationEn: 'Three hundred',
        illustration: '3️⃣0️⃣0️⃣',
        displayName: 'Kɛmɛ saba'
    },
    'Kɛmɛ naani': {
        translation: 'Quatre cents',
        translationEn: 'Four hundred',
        illustration: '4️⃣0️⃣0️⃣',
        displayName: 'Kɛmɛ naani'
    },
    'Kɛmɛ duuru': {
        translation: 'Cinq cents',
        translationEn: 'Five hundred',
        illustration: '5️⃣0️⃣0️⃣',
        displayName: 'Kɛmɛ duuru'
    },

    // Mille
    'Waa': {
        translation: 'Mille',
        translationEn: 'One thousand',
        illustration: '1️⃣0️⃣0️⃣0️⃣',
        displayName: 'Waa'
    },

    // Nombres composés exemples
    'Mugan ni kelen': {
        translation: 'Vingt-et-un',
        translationEn: 'Twenty-one',
        illustration: '2️⃣1️⃣',
        displayName: 'Mugan ni kelen'
    },
    'Kɛmɛ ni mugan': {
        translation: 'Cent vingt',
        translationEn: 'One hundred twenty',
        illustration: '1️⃣2️⃣0️⃣',
        displayName: 'Kɛmɛ ni mugan'
    },
    'Kɛmɛ ni bisaba ni duuru': {
        translation: 'Cent trente-cinq',
        translationEn: 'One hundred thirty-five',
        illustration: '1️⃣3️⃣5️⃣',
        displayName: 'Kɛmɛ ni bisaba ni duuru'
    },

    // Valeurs en Franc CFA - Pièces de monnaie
    'Tama kelen': {
        translation: '1 Franc CFA',
        translationEn: '1 CFA Franc',
        illustration: '🪙',
        audio: 'Ba-tama_kelen',
        displayName: 'Tama kelen'
    },
    'Tama fila': {
        translation: '2 Francs CFA',
        translationEn: '2 CFA Francs',
        illustration: '🪙',
        audio: 'Ba-tama_fila',
        displayName: 'Tama fila'
    },
    'Tama saba': {
        translation: '3 Francs CFA',
        translationEn: '3 CFA Francs',
        illustration: '🪙',
        audio: 'Ba-tama_saba',
        displayName: 'Tama saba'
    },
    'Tama naani': {
        translation: '4 Francs CFA',
        translationEn: '4 CFA Francs',
        illustration: '🪙',
        audio: 'Ba-tama_naani',
        displayName: 'Tama naani'
    },
    'Tama duuru': {
        translation: '5 Francs CFA',
        translationEn: '5 CFA Francs',
        illustration: '🪙',
        displayName: 'Tama duuru'
    },
    'Tama wɔɔrɔ': {
        translation: '6 Francs CFA',
        translationEn: '6 CFA Francs',
        illustration: '🪙',
        displayName: 'Tama wɔɔrɔ'
    },

    'Dɔrɔme kelen': {
        translation: '5 Francs CFA (pièce dorée)',
        translationEn: '5 CFA Francs (golden coin)',
        illustration: '🟡',
        audio: 'Ba-dorome_kelen',
        displayName: 'Dɔrɔme kelen'
    },

    'Dɔrɔme fila': {
        translation: '10 Francs CFA (2 x 5F)',
        translationEn: '10 CFA Francs (2 x 5F)',
        illustration: '🪙',
        audio: 'Ba-dorome_fila',
        displayName: 'Dɔrɔme fila'
    },

      'Dɔrɔme duuru': {
        translation: '25 Francs CFA (5 x 5F)',
        translationEn: '25 CFA Francs (5 x 5F)',
        illustration: '🪙',
        displayName: 'Dɔrɔme fila'
    },

    // Billets de banque
    'Dɔrɔme mugan': {
        translation: '100 Francs CFA',
        translationEn: '100 CFA Francs',
        illustration: '💵',
        audio: 'Ba-dorome_keme',
        displayName: 'Dɔrɔme keme'
    },

     'Dɔrɔme keme': {
        translation: '500 Francs CFA',
        translationEn: '500 CFA Francs',
        illustration: '💵',
        displayName: 'Dɔrɔme keme duuru'
    },
    'Dɔrɔme keme fila': {
        translation: '1000 Francs CFA',
        translationEn: '1000 CFA Francs',
        illustration: '💵',
        audio: 'Ba-dorome_keme_fila',
        displayName: 'Dɔrɔme keme fila'
    },

    'Dɔrɔme keme naani': {
        translation: '2000 Francs CFA',
        translationEn: '2000 CFA Francs',
        illustration: '💵',
        audio: 'Ba-dorome_keme_naani',
        displayName: 'Dɔrɔme keme naani'
    },

    'Dɔrɔme waga kelen': {
        translation: '5000 Francs CFA',
        translationEn: '5000 CFA Francs',
        illustration: '💵',
        audio: 'Ba-dorome_waga_kelen',
        displayName: 'Dɔrɔme waga kelen'
    },

    'Dɔrɔme waga fila': {
        translation: '10000 Francs CFA',
        translationEn: '10000 CFA Francs',
        illustration: '💵',
        audio: 'Ba-dorome_waga_fila',
        displayName: 'Dɔrɔme waga fila'
    },

};

export default nombres;

export {};
